module.exports = __webpack_public_path__ + "videos/hero_jp.e2f1cab.mp4";